import React, { ChangeEvent, useState } from "react";
import "./DashboardEntryPanasonicInfoModal.scss";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import OwButton from "../../../shared/OwButton/OwButton";
import OwTextArea from "../../../shared/OwTextArea/OwTextArea";

type Props = {
    section: "project_description" | "end_user_engagement" | "competitive_information";
    textValue: string;
    closeModal: (section: "project_description" | "end_user_engagement" | "competitive_information", textValue?: string) => void;
};

export const DashboardEntryPanasonicInfoModal = (props: Props) => {
    const [textValue, setTextValue] = useState(props.textValue);

    const handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        setTextValue(value);
    };

    return (
        <div className={"DashboardEntryPanasonicInfoModal"}>
            <div className={"d-flex justify-content-between"}>
                <OwTitle title={props.section} tag={"h5"} />
                <div>
                    <OwButton
                        className={"btn-danger"}
                        centerIconClass={"fas fa-times"}
                        fn={() => {
                            props.closeModal(props.section);
                        }}
                    />
                </div>
            </div>
            <OwTextArea rows={7} fn={handleChange} name={props.section} value={textValue} />
            <div className={"d-flex justify-content-between mt-2"}>
                <OwButton
                    title={"accept"}
                    fn={() => {
                        props.closeModal(props.section, textValue);
                    }}
                />
                <div>{textValue.length}</div>
            </div>
        </div>
    );
};
